import { useAuthenticationState } from '@hooks/useAuthenticationState';
import { GoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import { Flex } from '@aircall/tractor-v2';
import { useElementSize } from 'usehooks-ts';

export function GoogleLoginButton() {
  const {
    actions: { signInWithGoogle },
  } = useAuthenticationState();
  const { i18n } = useTranslation();
  const [containerRef, { width }] = useElementSize();

  return (
    <Flex w='100%' data-test='google-signin-button' justifyContent='center' ref={containerRef}>
      <GoogleLogin
        text='signin'
        locale={i18n.language}
        onSuccess={signInWithGoogle}
        width={width.toString()}
      />
    </Flex>
  );
}
